import React, { Fragment, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";

import { isIn, scopeIsModalPlayer, text_truncate } from "../../../../helpers";
import {
  CUSTOM_SCOPES,
  FILTER_KEYS,
  QUARTER,
  SCOPE,
  STATUS_FILTER,
} from "../../../../config/constants";
import { useFiltersState } from "../../../../store/hooks";
import {
  SimpleMultiSelectorData,
  SimpleMultiSelectorItem,
  SimpleMultiSelectorPresentationalPropsType,
  SimpleMultiSelectorPropsType,
  SimpleMultiSelectorWrappedPropsType,
} from "./types";
import { useRouter } from "../../../../helpers/customHooks";
import { ParamWrapper } from "../ParamWrapper";
import "./styles.scss";


export const SimpleMultiSelectorPresentational = <
  T extends SimpleMultiSelectorItem
>({
  forceScope,
  filterData,
  changeFilterData,
  show,
  close,
  open,
  type,
  onApply,
  editable,
  isCustomIntensity,
  teamId,
}: SimpleMultiSelectorPresentationalPropsType<T>) => {
  const { specificScope: specificScopePrime } = useRouter();
  const specificScope = forceScope || specificScopePrime;
  const { [FILTER_KEYS.PLAY_TYPE]: playTypeSelected } = useFiltersState(
    forceScope!,
    FILTER_KEYS.PLAY_TYPE
  );
  const [disablePreGame, setDisablePreGame] = useState(false);
  const [lockPreGame, setLockPreGame] = useState(false);

  const { types, title } = type;
  const [allSelected, setAllSelected] = useState(
    specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB ||
      specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST ||
      forceScope === "INTENSITY_DROPDOWN" ||
      forceScope === "INTENSITY_DROPDOWN_HEADER"
      ? types.every((type) => isIn(filterData, type))
      : filterData.length === 0
  );
  const [newItems, setNewItems] = useState<T[]>(
    specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB ||
      specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST ||
      forceScope === "INTENSITY_DROPDOWN" ||
      forceScope === "INTENSITY_DROPDOWN_HEADER"
      ? filterData
      : filterData.length === 0
      ? types
      : filterData
  );

  useEffect(() => {
    if (
      (type.name === QUARTER.name && playTypeSelected?.name === "In-Play") ||
      (type.name === QUARTER.name && playTypeSelected?.name === "Out-Of-Play")
    ) {
      if (newItems.length === 1 && newItems[0].value === "Q0") {
        changeFilterData([]);
      } else if (newItems.some((x) => x.value === "Q0")) {
        const inPlayItems = newItems.filter((x) => x.value !== "Q0");
        changeFilterData(inPlayItems);
        if (onApply) {
          onApply();
        }
      }
      setDisablePreGame(true);
    } else {
      setDisablePreGame(false);
    }
    if (playTypeSelected?.name === "Pre-Game") {
      setLockPreGame(true);
      changeFilterData([{ value: "Q0", name: "Pre-Game" }] as T[]);
      if (onApply) {
        onApply();
      }
    } else {
      setLockPreGame(false);
    }
  }, [playTypeSelected]);

  useEffect(() => {
    if (type.name === STATUS_FILTER.name) {
      changeFilterData([
        { value: "ACT", name: "ACT" },
        { value: "DEV", name: "DEV" },
      ] as T[]);
    }
  }, []);

  useEffect(() => {
    if (filterData.length !== 0 && isCustomIntensity) {
      changeFilterData([]);
      setNewItems(types);
      setAllSelected(true);
    }
  }, [teamId]);

  const [appliqued, setAppliqued] = useState(false);
  const itemsChecks: JSX.Element[] = [];
  const onOpen = () => {
    open();
    if (disablePreGame) {
      const items =
        filterData.length === 0
          ? types.filter((value) => value.value !== "Q0")
          : filterData.filter((value) => value.value !== "Q0");
      setNewItems(items);
    } else {
      setNewItems(
        specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB ||
          specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST ||
          forceScope === "INTENSITY_DROPDOWN" ||
          forceScope === "INTENSITY_DROPDOWN_HEADER"
          ? filterData
          : filterData.length === 0
          ? types
          : filterData
      );
    }
    setAllSelected(
      specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB ||
        specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST ||
        forceScope === "INTENSITY_DROPDOWN" ||
        forceScope === "INTENSITY_DROPDOWN_HEADER"
        ? types.every((type) => isIn(filterData, type))
        : filterData.length === 0
    );
  };
  const onClosed = () => {
    close();
  };

  const erase = (
    array: SimpleMultiSelectorItem[],
    element: SimpleMultiSelectorItem
  ) => array.filter((item) => JSON.stringify(item) !== JSON.stringify(element));
  const addItem = (item: any) => {
    let copyNewItems = [...newItems];
    if (!isIn(newItems, item)) {
      copyNewItems.push(item);
    } else {
      copyNewItems = erase(copyNewItems, item) as T[];
    }
    setNewItems(copyNewItems);
    if (types.every((type) => isIn(copyNewItems, type))) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  };
  types.forEach((type, index) => {
    const id =
      (specificScope ? specificScope + "-" : "") +
      "check-" +
      JSON.stringify(type) +
      title;
    itemsChecks.push(
      <Fragment key={index + type.value}>
        <input
          className="styled-checkbox"
          id={id}
          checked={
            lockPreGame && type.name !== "Pre-Game"
              ? false
              : lockPreGame && type.name === "Pre-Game"
              ? true
              : isIn(newItems, type)
          }
          type="checkbox"
          value={type.value}
          onChange={() => {
            if (type.name !== "Pre-Game" || !lockPreGame) addItem(type);
          }}
          disabled={
            lockPreGame && type.name !== "Pre-Game"
              ? true
              : type.name === "Pre-Game" && disablePreGame
          }
        />
        <label
          id={`label-period-${type.name}`}
          htmlFor={id}
          className="check-l"
        >
          {type.name}
        </label>
      </Fragment>
    );
  });
  return (
    <Dropdown
      className={
        forceScope === "INTENSITY_DROPDOWN_HEADER"
          ? "select-00 profile-dropdown dropdown"
          : forceScope !== "INTENSITY_DROPDOWN"
          ? "intensive-00 filter-f2 simple-multi-selector-dropdown-" +
            type.name.split(" ").join("_")
          : ""
      }
      show={show}
      onToggle={show ? onClosed : onOpen}
    >
      <Dropdown.Toggle
        disabled={editable}
        id={`dropdown-basic-multi-selector-${title.split(" ").join("_")}`}
        className={
          forceScope === "INTENSITY_DROPDOWN_HEADER"
            ? "intensive-00 filter-f2 simple-multi-selector-dropdown-Period_Type show dropdown"
            : forceScope !== "INTENSITY_DROPDOWN"
            ? "btn-border more-arrow-after"
            : "padding-profile-items btn-gray-l dropdown-toggle btn btn-primary"
        }
        style={
          scopeIsModalPlayer(specificScope)
            ? { width: "117px" }
            : forceScope === "INTENSITY_DROPDOWN"
            ? { width: "163.8px", height: "32px" }
            : forceScope === "INTENSITY_DROPDOWN_HEADER"
            ? { width: "93px" }
            : forceScope?.includes("PRACTICE_TRACKING")
            ? { width: "150px" }
            : { width: "120px" }
        }
      >
        {specificScope !== CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB &&
        forceScope !== "INTENSITY_DROPDOWN" &&
        forceScope !== "INTENSITY_DROPDOWN_HEADER" ? (
          <label className={appliqued ? "appliqued" : ""}>{title}</label>
        ) : (forceScope === "INTENSITY_DROPDOWN" ||
            forceScope === "INTENSITY_DROPDOWN_HEADER") &&
          (filterData.length === 0 ||
            (filterData.length === 1 && filterData[0].value === "")) ? (
          <label style={{ marginBottom: "0px" }}>Select</label>
        ) : null}
        <span>
          {disablePreGame && filterData.some((e) => e.value === "Q0")
            ? filterData.length === 0
              ? "All"
              : filterData.length === 1
              ? filterData[0].name
              : filterData.length === 2 && filterData[0].value === "Q0"
              ? filterData[1].name
              : filterData.length === 2 && filterData[1].value === "Q0"
              ? filterData[0].name
              : "Multiple (" + (filterData.length - 1) + ")"
            : specificScope.includes("PRACTICE_TRACKING")
            ? filterData.length === 0
              ? "ACT/DEV/CUT/RES"
              : `${filterData.map((value) => value.name).join("/")}`
            : filterData.length === 0
            ? specificScope ===
                CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB ||
              specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST ||
              forceScope === "INTENSITY_DROPDOWN" ||
              forceScope === "INTENSITY_DROPDOWN_HEADER"
              ? ""
              : specificScope === SCOPE.ACCOUNT.PAGE ||
                specificScope === SCOPE.PLAYERS.PAGE
              ? "All Positions"
              : "All"
            : filterData.length === 1 && filterData[0].value !== ""
            ? text_truncate(
                filterData[0].name,
                13 +
                  +(
                    specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST ||
                    forceScope === "INTENSITY_DROPDOWN" ||
                    forceScope === "INTENSITY_DROPDOWN_HEADER"
                  ) *
                    1,
                "..."
              )
            : filterData.length === 2
            ? text_truncate(
                filterData[0].name,
                9 +
                  +(
                    specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST ||
                    forceScope === "INTENSITY_DROPDOWN"
                  ) *
                    5,
                "..."
              ) + " (+1)"
            : "Multiple (" + filterData.length + ")"}
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu className={"simple-multi-selector-dropdown-menu"}>
        <div className="p-h-01">
          Select All
          <div
            className="p-i-01"
            style={lockPreGame ? { opacity: "0.5", pointerEvents: "none" } : {}}
          >
            <input
              type="checkbox"
              id={specificScope + "-all-selected-" + title}
              name="set-name"
              className="switch-input"
              checked={lockPreGame ? true : allSelected}
              onChange={() => {
                if (!lockPreGame) {
                  if (allSelected) {
                    setNewItems([]);
                    setAllSelected(false);
                  } else {
                    const items =
                      disablePreGame && type.name === QUARTER.name
                        ? types.filter((value) => value.value !== "Q0")
                        : types;
                    setNewItems(items);
                    setAllSelected(true);
                  }
                }
              }}
            />
            <label
              id={"all-selected-" + title}
              htmlFor={specificScope + "-all-selected-" + type.title}
              className="switch-label"
            />
          </div>
        </div>
        <div className={"p-b-010"}>
          <div
            className={"p-b-02"}
            style={
              forceScope === CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST ||
              forceScope === CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB
                ? { height: "220px" }
                : forceScope === "INTENSITY_DROPDOWN"
                ? { height: "150px" }
                : forceScope === "INTENSITY_DROPDOWN_HEADER"
                ? { width: "160px" }
                : {}
            }
          >
            {itemsChecks}
          </div>
        </div>
        <div className="footer-s">
          <button
            id={
              forceScope === "INTENSITY_DROPDOWN"
                ? "intenisity-Cancel"
                : "period-Cancel"
            }
            className="btn-transparet"
            onClick={close}
          >
            Cancel
          </button>
          <button
            id={
              forceScope === "INTENSITY_DROPDOWN"
                ? "intenisity-Apply"
                : "period-Apply"
            }
            className={
              "btn-blue " +
              (specificScope !==
                CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB &&
              specificScope !== CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST &&
              forceScope !== "INTENSITY_DROPDOWN" &&
              newItems.length === 0
                ? "opacity-50"
                : "")
            }
            onClick={() => {
              onClosed();
              setAppliqued(true);
              changeFilterData(
                specificScope ===
                  CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB ||
                  specificScope === CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST ||
                  forceScope === "INTENSITY_DROPDOWN" ||
                  forceScope === "INTENSITY_DROPDOWN_HEADER"
                  ? newItems
                  : types.every((type) => isIn(newItems, type))
                  ? []
                  : newItems
                /*teamId*/
              );
              if (onApply) {
                onApply();
              }
            }}
            disabled={specificScope !==
                CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB &&
              specificScope !== CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST &&
              forceScope !== "INTENSITY_DROPDOWN" &&
              newItems.length === 0}
          >
            Apply
          </button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const SimpleMultiSelectorWrapped = <T extends SimpleMultiSelectorItem>({
  type,
  forceScope,
  changeFilterDataWrapped,
  ...restProps
}: SimpleMultiSelectorWrappedPropsType<T>) => {
  const { specificScope: specificScopePrime } = useRouter();
  const specificScope = forceScope || specificScopePrime;
  const { [type.filterKey]: filtersState } = useFiltersState(
    specificScope,
    type.filterKey
  );

  return (
    <SimpleMultiSelectorPresentational
      {...restProps}
      type={type}
      forceScope={forceScope}
      filterData={filtersState as T[]}
      changeFilterData={(items: T[]) => changeFilterDataWrapped(items)()}
    />
  );
};

export const SimpleMultiSelector = <T extends SimpleMultiSelectorItem>(
  props: SimpleMultiSelectorPropsType<T>
) => {
  return (
    <ParamWrapper
      fromUrlSearchParam={(cad, props) => {
        if (cad) {
          const values = cad.split(",");
          return props.type.types.filter((value) =>
            values.some((v) => v === value.value)
          );
        }
        return [];
      }}
      toUrlSearchParam={(selectedItems: SimpleMultiSelectorData) => {
        if (Array.isArray(selectedItems)) {
          return selectedItems
            .map((value: { value: string }) => value.value)
            .join(",");
        }
        return "";
      }}
      Component={SimpleMultiSelectorWrapped}
      props={props}
      filterKey={props.type.filterKey}
    />
  );
};

export default SimpleMultiSelector;
